var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDebuggerNoLabelsIcon = function SvgDebuggerNoLabelsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none",
    viewBox: "0 0 50 51"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#19A979",
    d: "m33.093 17.628 5.056 7.579a1.41 1.41 0 0 1 0 1.575l-5.056 7.579a1.41 1.41 0 0 1-1.185.639H13.47a.46.46 0 0 1-.414-.249.47.47 0 0 1 .023-.485l5.33-8.005a.46.46 0 0 0 0-.521l-5.33-8.006A.473.473 0 0 1 13.47 17h18.438a1.43 1.43 0 0 1 1.185.628",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "m37.733 25.484.002.002a.91.91 0 0 1 0 1.016l-.002.002-5.056 7.579h0l-.003.004a.91.91 0 0 1-.764.413H13.524l5.3-7.96a.96.96 0 0 0 0-1.08l-5.3-7.96h18.384a.93.93 0 0 1 .77.407l.001.002zm-24.237 9.059h0ZM.5.5h49M.5 50.5h49"
  })));
};
export default SvgDebuggerNoLabelsIcon;